import FlatCard from "components/UI-lib/FlatCard";
import LaunchableConfigurationView from "../shared/LaunchableConfigurationView";
import { dummyInstanceObject } from "components/Environment/utils";
import React from "react";
import LaunchableInteractive from "../../List/LaunchableInteractive";

export const LaunchableNotFound: React.FC = () => (
  <>
    <div className="flex flex-row mt-8 justify-center">
      <div className="flex flex-col justify-center">
        <div className="text-red-500 text-sm p-2r ounded font-bold text-xl">
          Launchable Not Found
        </div>
        <span className="text-sm text-primary font-semibold mt-2">
          Either the launchable id does not exist or was deleted.
        </span>
      </div>
      <div className="relative">
        <LaunchableInteractive
          isSectionInfoEnabled={false}
          isAnimationEnabled={true}
        />
      </div>
    </div>
  </>
);
